import React from 'react';
import styled from 'styled-components';
import {
  brandColours,
  fontSize,
  minBreakpointQuery,
  sectionMargins,
  standardColours,
} from '../styles';
import { Container, Heading, Svg } from './ui';
import NewsletterSignupForm from './NewsletterSignupForm';
import emailIcon from '../images/email-icon.inline.svg';

const StyledNewsletterSignup = styled.section`
  ${sectionMargins()};
`;

const StyledInner = styled.div`
  padding: 30px;
  color: ${standardColours.white};
  background-color: ${brandColours.primary};
  border-radius: 15px;

  ${minBreakpointQuery.small`
    padding: 40px;
  `}

  ${minBreakpointQuery.large`
    padding: 50px;
  `}

  ${minBreakpointQuery.xxlarge`
    padding: 60px;
  `}
`;

const StyledWrapper = styled.div`
  margin: 0 auto;
  max-width: 500px;
  text-align: center;
`;

const StyledHeader = styled.header``;

const StyledIcon = styled(Svg)`
  margin-bottom: 8px;
  height: 30px;
  width: 30px;

  ${minBreakpointQuery.small`
    margin-bottom: 10px;
    height: 40px;
    width: 40px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 12px;
    height: 50px;
    width: 50px;
  `}
`;

const StyledText = styled.p`
  margin-top: 8px;
  ${fontSize(14)};
  line-height: 1.4;

  ${minBreakpointQuery.small`
    margin-top: 10px;
    ${fontSize(15)};
  `}

  ${minBreakpointQuery.large`
    margin-top: 12px;
    ${fontSize(16)};
  `}
`;

const StyledForm = styled(NewsletterSignupForm)`
  margin-top: 16px;

  ${minBreakpointQuery.small`
    margin-top: 20px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 24px;
  `}
`;

const NewsletterSignup = ({ heading, text }) => (
  <StyledNewsletterSignup>
    <Container>
      <StyledInner>
        <StyledWrapper>
          <StyledHeader>
            <StyledIcon image={emailIcon} />
            <Heading>{heading}</Heading>
            <StyledText>{text}</StyledText>
          </StyledHeader>
          <StyledForm />
        </StyledWrapper>
      </StyledInner>
    </Container>
  </StyledNewsletterSignup>
);

export default NewsletterSignup;
